// Configuration de l'API
// Utilise REACT_APP_API_URL depuis les variables d'environnement
// Par défaut: http://127.0.0.1:8000 (évite les soucis de résolution localhost / IPv6)

const raw = process.env.REACT_APP_API_URL || 'http://127.0.0.1:8000';
// Pas de slash final : évite http://host:8000//restaurants/ (certains serveurs répondent 404)
const API_BASE_URL = String(raw).trim().replace(/\/+$/, '');

if (process.env.NODE_ENV === 'development' && typeof console !== 'undefined') {
  // Aide au diagnostic des 404 (API injoignable ou mauvaise URL)
  console.info('[api] REACT_APP_API_URL →', API_BASE_URL);
}

export default API_BASE_URL;
